import { FC } from 'react';

const Policy: FC = () => {
  return <>Policy</>;
};

export default Policy;
